import { useNavigate, useLocation } from "react-router-dom";
import { capitalizeWords } from "./capitalizeWords";
import formatDate from "./dateUtils";
import avatar from "../../assets/images/avatar.webp";

const TotalLeaveRequestTable = () => {
  const location = useLocation();
  const requestedLeavesToday = location.state.requestedLeavesToday;
  const navigate = useNavigate();

  return (
    <div className="board__layout">
      <div className="section-header">
        <div className="header__titles">
          <button onClick={() => navigate("/leavemanagement")}>
            <span>
              <i className="ri-arrow-left-s-line"></i>
            </span>
            BACK
          </button>
          <h4>Total Leave Requests in the Last 90 Days</h4>
        </div>
      </div>

      <table className="table px-4">
        <thead>
          <tr>
            <th>SL No.</th>
            <th colSpan="2">Employee Details</th>
            <th>Applied Date</th>
            <th>Leave Start Date</th>
            <th>Leave End Date</th>
            <th>No Of Days</th>
            <th>Leave Type</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {requestedLeavesToday
            .filter((leave) => {
              const today = new Date();
              const ninetyDaysAgo = new Date();
              ninetyDaysAgo.setDate(today.getDate() - 90);
              const appliedDate = new Date(leave.apply_date);
              return appliedDate >= ninetyDaysAgo && appliedDate <= today;
            })
            .map((leave, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className="leave_empImage">
                  <img
                    src={
                      leave?.user?.profile_picture
                        ? leave?.user?.profile_picture
                        : avatar
                    }
                    alt="Employee"
                  />
                </td>
                <td className="leave_empDetails">
                  <div className="leave_empName">
                    {capitalizeWords(leave?.user?.employee_full_name)}
                  </div>
                  <div className="leave_designation">
                    {leave?.user?.roles[0]?.role_name}
                  </div>
                  <div className="leave_id">ID:{leave?.user?.employee_id}</div>
                </td>
                <td>{formatDate(leave.apply_date)}</td>
                <td>{formatDate(leave.leave_from)}</td>
                <td>{formatDate(leave.leave_to)}</td>
                <td>{leave.days_count}</td>
                <td>{leave.leave_type}</td>
                <td>
                  {leave.is_approved === 1 && (
                    <span className="approved">Approved</span>
                  )}
                  {leave.is_approved === 0 && (
                    <span className="rejected">Declined</span>
                  )}
                  {leave.is_approved === null && (
                    <span className="pending">Pending</span>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TotalLeaveRequestTable;
